module.exports = __webpack_public_path__ + "static/media/north-star.da9abafb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/section-images/north-star.svg
// module id = 94
// module chunks = 0